import common from "../common";
import QuestionModule from "./modules/QuestionModule";
import QuestionModuleAlgebra from "./modules/QuestionModuleAlgebra";
import QuestionModuleArithmetic from "./modules/QuestionModuleArithmetic";
import QuestionModuleArithmeticRoman from "./modules/QuestionModuleArithmeticRoman";
import QuestionModuleBoolean from "./modules/QuestionModuleBoolean";
import QuestionModuleExponent from "./modules/QuestionModuleExponent";
import QuestionModuleFractionArithmetic from "./modules/QuestionModuleFractionArithmetic";
import QuestionModuleMeasurement from "./modules/QuestionModuleMeasurement";
import QuestionModuleMultiples from "./modules/QuestionModuleMultiples";
import QuestionModulePlaceValue from "./modules/QuestionModulePlaceValue";
import QuestionModuleRatio from "./modules/QuestionModuleRatio";
import QuestionModuleSequence from "./modules/QuestionModuleSequence";
import QuestionModuleShapes from "./modules/QuestionModuleShapes";
import QuestionModuleSorting from "./modules/QuestionModuleSorting";
import QuestionModuleStatic from "./modules/QuestionModuleStatic";
import QuestionModuleStats from "./modules/QuestionModuleStats";
import QuestionModuleSum from "./modules/QuestionModuleSum";
import QuestionModuleTimesTable from "./modules/QuestionModuleTimesTable";
import QuestionModuleVisual from "./modules/QuestionModuleVisual";
import QuestionModel from "./QuestionModel";
import seedrandom from "seedrandom";
import WeeklyChallenge from "../WeeklyChallenge";

export default class QuestionFactory {
    constructor(modules, difficulty = 0, seed) {
        this._difficulty = difficulty;
        this._data = [];
        this._seenData = [];

        const questions = P3.assets.json("questions");

        if (modules.all) {
            for (let i in questions) {
                if (questions.hasOwnProperty(i)) {
                    if (i === QuestionModule.MODULE_TUTORIAL) continue;
                    const t = questions[i].filter(x => x.enabled && x.difficulty === difficulty);
                    for (let j = 0; j < t.length; ++j) t[j].module = i;  // we add 'module' as a property
                    this._data = this._data.concat(t);
                }
            }
        } else {
            for (const i in modules) {
                if (modules.hasOwnProperty(i)) {
                    for (let j = 0; j < modules[i].length; ++j) {
                        const type = modules[i][j];
                        const t = questions[i].filter(x => x.type === type && x.enabled === true &&
                            (Array.isArray(x.difficulty) ? x.difficulty.indexOf(difficulty) !== -1 : x.difficulty === difficulty));

                        for (let j = 0; j < t.length; ++j) t[j].module = i;  // we add 'module' as a property

                        this._data = this._data.concat(t);
                    }
                }
            }
        }

        //grab static questions for this location, filter by difficulty, pick a single one randomly
        const questionsStatic = P3.assets.json('static_questions')[common.location.id];
        if (questionsStatic) {
            const t = questionsStatic.filter((x) => (Array.isArray(x.difficulty) ? x.difficulty.indexOf(difficulty) !== -1 : x.difficulty === difficulty));
            t.length > 0 && this._data.push(P3.utils.selectRandom(t));
        }

        if (!this._data.length) throw new Error("No questions available!");
    }

    createQuestion() {
        let t;

        let k = 100;
        while (k-- > 0) {
            t = P3.utils.selectRandom(this._data);
            const tString = JSON.stringify(t);

            if (t.module === "static") console.log("adding static question", t);
            if (this._seenData.indexOf(tString) === -1) {
                this._seenData.push(tString);
                break;
            }
        }

        if (this._seenData.length === this._data.length) {
            this._seenData.length = 0;
        }

        return this._createModule(t);
    }

    createQuestionWithSeed(index)
    {
        const questions = WeeklyChallenge.questions[common.week - 1][this._difficulty];
        const t = questions[index % questions.length];
        return this._createModule(t);
    }

    _createModule(t)
    {
        switch (t.module) {
            case QuestionModule.MODULE_ARITHMETIC : {
                return new QuestionModuleArithmetic().create(t);
            }
            case QuestionModule.MODULE_ALGEBRA : {
                return new QuestionModuleAlgebra().create(t);
            }
            case QuestionModule.MODULE_PLACE_VALUE : {
                return new QuestionModulePlaceValue().create(t);
            }
            case QuestionModule.MODULE_VISUAL : {
                return new QuestionModuleVisual().create(t);
            }
            case QuestionModule.MODULE_FRACTION_ARITHMETIC : {
                return new QuestionModuleFractionArithmetic().create(t);
            }
            case QuestionModule.MODULE_ROMAN_ARITHMETIC : {
                return new QuestionModuleArithmeticRoman().create(t);
            }
            case QuestionModule.MODULE_SORTING : {
                return new QuestionModuleSorting().create(t);
            }
            case QuestionModule.MODULE_BOOLEAN : {
                return new QuestionModuleBoolean().create(t);
            }
            case QuestionModule.MODULE_SHAPES : {
                return new QuestionModuleShapes().create(t);
            }
            case QuestionModule.MODULE_SEQUENCE : {
                return new QuestionModuleSequence().create(t);
            }
            case QuestionModule.MODULE_EXPONENT : {
                return new QuestionModuleExponent().create(t);
            }
            case QuestionModule.MODULE_MEASUREMENT : {
                return new QuestionModuleMeasurement().create(t);
            }
            case QuestionModule.MODULE_RATIO : {
                return new QuestionModuleRatio().create(t);
            }
            case QuestionModule.MODULE_STATS : {
                return new QuestionModuleStats().create(t);
            }
            case QuestionModule.MODULE_MULTIPLES : {
                return new QuestionModuleMultiples().create(t);
            }
            case QuestionModule.MODULE_SUM : {
                return new QuestionModuleSum().create(t);
            }
            case QuestionModule.MODULE_STATIC : {
                return new QuestionModuleStatic().create(t);
            }
            case QuestionModule.MODULE_TIMES_TABLE : {
                return new QuestionModuleTimesTable().create(t);
            }
        }
        throw new Error("Module not found: " + t.module);
    }
}